/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { LoggerModule } from "@vlinder-web/logger-module-react";
import _ from "lodash";
import { VApplication } from "../application";

import { GraphqlServerModule } from '@vlinder-web/graphql-server-module-react';
import { humanize } from "uno-js";
// import { data } from "./config/profile-data"

import {EDIT_APP_FEE} from "../pages/ApplicationFee/graphql"

import { toast } from "react-hot-toast"

const MODULE_NAME = "ApplicationFeeService";
const log: any = LoggerModule.getInstance();

const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync('services.GraphqlServerModule') as GraphqlServerModule;
};

export class EditApplicationFeeService {
    private static instance: EditApplicationFeeService;
    private vapp: VApplication;
    private termsURL: string;
    private constructor(props: any = {}) {
        this.vapp = VApplication.getInstance();
        this.termsURL = props?.termsURL
    }
    public static getInstance(props: any = {}): EditApplicationFeeService {
        if (!EditApplicationFeeService.instance) {
            EditApplicationFeeService.instance = new EditApplicationFeeService(props);
        }
        return EditApplicationFeeService.instance;
    }



    async editApplicationFee(data: any) {
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        log.blue(MODULE_NAME, `EDIT Application Fee  data in service`, data);
        try {
            if (client) {
                const res = await client.mutate({
                    mutation: EDIT_APP_FEE,
                    variables: {
                        input: data
                    },

                    fetchPolicy: "no-cache",
                });
                log.success(MODULE_NAME, "EDIT Profile: ", res);
                if (res) {
                    return res
                }
            }
        } catch (err: any) {
            err?.graphQLErrors &&
                Array.isArray(err?.graphQLErrors) &&
                err?.graphQLErrors.length > 0 &&
                toast.error(err?.graphQLErrors[0]?.message);
        }
    }

    
}
